import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/shell')({
  head: () => ({
    meta: [{ name: 'robots', content: 'noindex, nofollow' }],
  }),
  component: ShellRoute,
});

function ShellRoute() {
  return null;
}
